export default "__VITE_ASSET__Bon1olJ2__"